export default {
  logout: 'Выйти',
  login: 'Войти',
  personalAccount: 'Личный кабинет',
  messages: 'Сообщения',
  models: 'Модели',
  statistics: 'Статистика',
  menu: 'Меню',
  noNewMessages: 'Нет новых сообщений',
  selectCompany: 'Выберите компанию',
  withoutCompany: 'Без компании',
  manageCompany: 'Управление компаниями',
  marketing: 'Маркетинг',
  digitalCatalog: 'Цифровой каталог',
  estimate: 'Проектная потребность',
  lobby: 'Лобби',
  showCase: 'Витрина моделей',
  plugins: 'Плагины',
  dashboard: 'Статистика',
  tarifs: 'Тарифы',
  articles: 'Статьи',
  videos: 'Видеоролики',
  products: 'Продукция',
  ntd: 'НТД',
  properties: 'Свойства',
  map: 'Карта / Таблица объектов',
  stocks: 'Акции',
  deposit: 'Депозит',
  documents: 'Документы',
  profile: 'Мой профиль',
  companies: 'Мои компании',
  settings: 'Настройки',
  support: 'Техподдержка',
}
